export default "__VITE_ASSET__ca90b6d6__"